import { getAndApplyAdobeTargetOffers } from '@rei/adobe-target-functions';

const selectors = {
  container: '.email-signup__container',
  header: '.email-signup__header-text',
  subheader: '.email-signup__subheader-text',
  inputLabel: '.email-signup__input-label',
  button: '.email-signup__button',
  emailIcon: '.email-signup__input-icon-wrapper',
  form: '.email-signup__form',
};

const items = [
  {
    label: 'Limited-time offers, coupons & upcoming sales',
  },
  {
    label: 'Gear advice, expert tips, local events & classes',
  },
  {
    label: 'Plus, 15% off one REI Co-op brand item!',
    cta: {
      label: ' Details',
      href: '/help/rei-email-subscription',
    },
  },
];

function buildFooterDOM() {
  const container = document.querySelector(selectors.container);
  container.classList.add('is-challenger');
  const header = document.querySelector(selectors.header);
  header.textContent = 'Connect with the co-op:';

  document.querySelector(selectors.subheader).remove();
  document.querySelector(selectors.emailIcon).remove();

  const label = document.querySelector(selectors.inputLabel);
  label.textContent = 'Email *';

  const ul = document.createElement('ul');
  ul.classList.add('email-signup__subheader-container');

  const div = document.createElement('div');
  div.classList.add('email-signup__privacy-container');

  const p = document.createElement('p');
  p.classList.add('email-signup__privacy-text');
  p.textContent = 'Read our ';

  const a = document.createElement('a');
  a.href = '/legal/privacy-notice';
  a.textContent = 'Privacy Policy';
  a.classList.add('email-signup__privacy-cta');

  p.appendChild(a);
  div.appendChild(p);

  const form = document.querySelector(selectors.form);
  form.appendChild(div);

  items.forEach((item) => {
    const li = document.createElement('li');

    const span = document.createElement('span');
    span.classList.add('email-signup__subheader-text');
    span.textContent = item.label;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('cdr-icon');
    svg.setAttribute('viewBox', '0 0 24 24');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('role', 'presentation');
    path.setAttribute('d', 'M16.77 8.645a1 1 0 10-1.533-1.286l-5.95 7.083-1.52-1.817a1 1 0 10-1.533 1.285l2.227 2.66a.999.999 0 001.565.1l6.743-8.025z');
    path.setAttribute('fill', '#1F513F');
    svg.prepend(path);

    if (item.cta) {
      span.textContent += ' ';
      const link = document.createElement('a');
      link.textContent = item.cta.label;
      link.href = item.cta.href;
      link.classList.add('email-signup__subheader-cta');
      span.appendChild(link);
    }

    span.insertAdjacentElement('afterbegin', svg);
    li.appendChild(span);
    ul.appendChild(li);
  });

  header.after(ul);
}

async function initExperimentation() {
  const componentData = { footerEmailSignupRedesign: {} };

  try {
    const response = await getAndApplyAdobeTargetOffers({ componentData });
    // eslint-disable-next-line no-console
    console.log('[footerABTest] Adobe Target data: ', response);
    if (response.offers && response.offers.length > 0) {
      const offer = response.offers[0];
      if (offer.componentName === 'footer-email-signup-redesign' && offer.variant === 'challenger') {
        buildFooterDOM();
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('[footerABTest] No offers received, applying default control');
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[footerABTest] Error fetching Adobe Target offers: ', error);
  }
}

export default initExperimentation;